module.exports = __webpack_public_path__ + "static/media/ih__agency_brochure_web.43b9527c.pdf";